// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BackButton_wrapper__1qbl9","label":"BackButton_label__3RWsL","title":"BackButton_title__3E8gL"};